import BlockOverlayContent from '@/components/layouts/BlockOverlayContent';
import cn from '@/utils/cn';

export interface BlockOverlayProps {
  title?: string;
  info?: string;
  subInfo?: string | React.ReactNode;
  /**
   * It is recommended to use either buttonLink or buttonConfirm, but not both.
   */
  buttonLink?: React.ReactNode;
  buttonConfirm?: {
    content: string;
    onClick?: () => void;
    withRightArrow?: boolean;
  };
  secondaryButtonContent?: string;
  onClose?: () => void;
  loading?: boolean;
  className?: string;
  classNameModal?: string;
  icon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  loadingIcon?: boolean;
  buttonFlexDirection?: 'flex-row' | 'flex-col';
  disabled?: boolean;
}

const BlockOverlay: React.FC<BlockOverlayProps> = ({
  title,
  info,
  subInfo,
  buttonLink,
  buttonConfirm,
  secondaryButtonContent,
  onClose,
  loading,
  className,
  classNameModal,
  icon,
  loadingIcon,
  disabled,
  buttonFlexDirection = 'flex-row',
}) => {
  return (
    <div
      className={
        'fixed left-0 top-0 z-[9999] flex size-full items-center justify-center bg-black/20 backdrop-blur-sm'
      }
    >
      <div className={'absolute size-full blur-sm'} />
      <div
        className={cn(
          'absolute flex size-full items-center justify-center',
          className
        )}
      >
        <div
          className={cn(
            'flex max-w-[310px] flex-col gap-y-6 rounded-[28px] bg-white p-6 blur-none lg:max-w-[360px] lg:p-8',
            classNameModal
          )}
        >
          <BlockOverlayContent
            title={title}
            info={info}
            subInfo={subInfo}
            buttonLink={buttonLink}
            buttonConfirm={buttonConfirm}
            secondaryButtonContent={secondaryButtonContent}
            onClose={onClose}
            loading={loading}
            icon={icon}
            loadingIcon={loadingIcon}
            disabled={disabled}
            buttonFlexDirection={buttonFlexDirection}
          />
        </div>
      </div>
    </div>
  );
};

export default BlockOverlay;
